// Fuzzy string match for the list / notes search box (issue #83). Case-insensitive and
// subsequence-based: every character of the query must appear in `text` in order, so
// "slppls" matches "sleeping pills" and a plain substring is always a match too. An
// empty (whitespace-only) query matches everything, so an unused search box hides nothing.
export const fuzzyMatch = (query, text) => {
    const q = query.trim().toLowerCase();
    if (q === "")
        return true;
    const t = text.toLowerCase();
    let qi = 0;
    for (let ti = 0; ti < t.length && qi < q.length; ti++) {
        if (t[ti] === q[qi])
            qi += 1;
    }
    return qi === q.length;
};
// True when the query fuzzily matches any of the given fields (name, notes, …). Undefined
// fields are skipped. An empty query matches (via `fuzzyMatch`), so callers get "show all".
export const fuzzyMatchAny = (query, ...fields) => {
    if (query.trim() === "")
        return true;
    return fields.some((f) => f !== undefined && fuzzyMatch(query, f));
};
//# sourceMappingURL=fuzzyMatch.js.map